import useAppState from '@/composables/ui/ui'
import { watch } from 'vue'
import usePostListMenu, { ActivePostPage } from '@/composables/ui/postListMenu'

export default function usePostSingleLoader() {
  const { postIdToShow } = useAppState()
  const { activePage } = usePostListMenu()

  const changeNewestList = () => {
    if (postIdToShow.value) {
      activePage.value = ActivePostPage.Show
    }
  }

  watch(postIdToShow, () => {
    if (postIdToShow.value) {
      changeNewestList()
    }
  })

  changeNewestList()

  return {}
}
